<div class="premium-dialog-header">
  <div class="dialog-badge-icon dialog-badge-emerald">
    <mat-icon>restore</mat-icon>
  </div>
  <h2>{{ 'quotation.id' | translate }} {{ quotation.erpId }}</h2>
</div>
<div mat-dialog-content>
  @if (error) {
    <div class="dialog-error">
      <p> {{ 'DATA_ERRORS.ERROR0' | translate }} : {{ error | error }}</p>
    </div>
  }
  <p class="m-0">{{ 'quotation.restoreMessage' | translate }}</p>
</div>
@if (progress) {
  <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
}
<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()" [disabled]="progress">
    {{ 'ADMIN.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="restore()" [disabled]="progress">
    <mat-icon>restore</mat-icon>
    {{ 'restore' | translate }}
  </button>
</div>
